/**
 * Colours of the map's rule symbols, shared by the routes, the border chevrons
 * and the map key (MapLegend) so they can never disagree. The map editor
 * mirrors these in tools/map-editor/app.js (MAP_SYMBOL_COLORS).
 */
export const MAP_SYMBOL_COLORS = {
  /** A plain crossing (sea route), and the one-way arrow. */
  route: '#0ea5e9',
  /** Worse dice for the attacker (e.g. 5 v 6): orange route. */
  disadvantage: '#f59e0b',
  /** Better dice for the attacker (e.g. 8 v 6): red route or chevron. */
  advantage: '#dc2626',
  /** Outline of the 8 v 6 chevrons: always the dark-mode version, on every theme. */
  chevronHalo: '#0a1610',
} as const

/** The 5 v 6 orange is darker on light backgrounds, where the bright one washes out. */
const DISADVANTAGE_LIGHT = '#c25e00'

/** A rule symbol's colour for the theme. */
export function mapSymbolColor(kind: keyof typeof MAP_SYMBOL_COLORS, theme: 'light' | 'dark'): string {
  return kind === 'disadvantage' && theme === 'light' ? DISADVANTAGE_LIGHT : MAP_SYMBOL_COLORS[kind]
}
